function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.11 6.855V3.615C10.11 3.495 10.065 3.39 9.97499 3.3L7.13999 0.495C7.06499 0.42 6.94499 0.375 6.83999 0.375H1.85999C1.61999 0.375 1.42499 0.57 1.42499 0.81V10.725C1.42499 10.965 1.61999 11.16 1.85999 11.16H5.78999C6.01499 13.11 7.66499 14.625 9.65999 14.625C11.805 14.625 13.56 12.87 13.56 10.725C13.575 8.715 12.06 7.065 10.11 6.855ZM7.00499 1.59L8.92499 3.48H7.00499V1.59ZM2.29499 1.245H6.11999V3.915C6.11999 4.155 6.31499 4.35 6.55499 4.35H9.22499V6.84C7.43999 7.05 5.99999 8.49 5.80499 10.29H2.29499V1.245ZM9.67499 13.755C8.00999 13.755 6.64499 12.405 6.64499 10.725C6.64499 9.045 7.99499 7.695 9.67499 7.695C11.355 7.695 12.705 9.045 12.705 10.725C12.705 12.405 11.34 13.755 9.67499 13.755Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.79502 8.775C9.72002 8.7 9.61502 8.7 9.54002 8.775L8.05502 10.395C7.95002 10.5 8.04002 10.68 8.19002 10.68H8.95502V12.45C8.95502 12.54 9.03002 12.63 9.13502 12.63H10.215C10.305 12.63 10.395 12.555 10.395 12.45V10.68H11.16C11.31 10.68 11.385 10.5 11.295 10.395L9.79502 8.775Z",
  fill: "currentColor"
});

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.ded73404.svg";
export { ForwardRef as ReactComponent };